import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { AppHealthService } from './app-health.service';

@Component({
  selector: 'zag-app-status',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span
      class="app-status"
      role="button"
      tabindex="0"
      [attr.aria-label]="isHealthy() ? 'Service online' : 'Service offline'"
      (click)="statusClick.emit()"
      (keydown)="onKeyActivate($event)"
    >
      <span
        class="app-status__dot"
        [class.app-status__dot--healthy]="isHealthy()"
        role="status"
        [attr.aria-label]="isHealthy() ? 'Service online' : 'Service offline'"
      ></span>
      @if (version()) {
        <span class="app-status__version">{{ version() }}</span>
      }
    </span>
  `,
  styles: [
    `
      .app-status {
        display: inline-flex;
        align-items: center;
        gap: var(--spacing-xs, 4px);
        cursor: pointer;
      }

      .app-status__dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        flex-shrink: 0;
        background: var(--color-neutral-400, #9ca3af);

        &.app-status__dot--healthy {
          background: var(--color-success, #22c55e);
        }
      }

      .app-status__version {
        font-size: var(--font-size-caption, 0.75rem);
        color: var(--text-color-secondary);
        font-variant-numeric: tabular-nums;
      }
    `,
  ],
})
export class AppStatusComponent {
  private readonly health = inject(AppHealthService);
  protected readonly isHealthy = this.health.isHealthy;
  protected readonly version = this.health.version;
  readonly statusClick = output<void>();

  protected onKeyActivate(event: KeyboardEvent): void {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    event.preventDefault();
    this.statusClick.emit();
  }
}
